{
	"type": "line",
	"minzoom": 7,
	"layout": {
		"line-cap": "round"
	},
	"paint": {
		"line-color": "#0911f9",
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 1, 18, 3],
		"line-offset": [
			"interpolate",
			["linear"],
			["zoom"],
			0,
			0,
			9,
			0,
			18,
			["match", ["get", "visual_offset"], "Right", 3, "Left", -3, 0]
		],
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 1]
	}
}
